import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

type DialogOptions = {
    title?: string
    confirmLabel?: string
    cancelLabel?: string
}

function useConfirmationDialog() {
    const [isOpen, setIsOpen] = useState(false)
    const [resolvePromise, setResolvePromise] = useState<((v: boolean) => (v: unknown) => void) | null>(null)
    const [message, setMessage] = useState('')
    const [dialogOptions, setDialogOptions] = useState<DialogOptions>({})

    const confirm = (msg: string, options: DialogOptions = {}) => {
        setMessage(msg)
        setDialogOptions({
            title: options.title || '',
            confirmLabel: options.confirmLabel || 'Ok',
            cancelLabel: options.cancelLabel || 'Avbryt',
        })
        setIsOpen(true)

        return new Promise((resolve) => {
            setResolvePromise(() => resolve)
        })
    }

    const handleClose = (result: boolean) => {
        setIsOpen(false)
        if (resolvePromise) resolvePromise(result)
    }

    const ConfirmationDialog = () =>
        isOpen
            ? ReactDOM.createPortal(
                  <Dialog open={true}>
                      {dialogOptions.title && <DialogTitle>{dialogOptions.title}</DialogTitle>}
                      <DialogContent>{message}</DialogContent>
                      <DialogActions>
                          <Button onClick={() => handleClose(false)}>{dialogOptions.cancelLabel}</Button>
                          <Button onClick={() => handleClose(true)}>{dialogOptions.confirmLabel}</Button>
                      </DialogActions>
                  </Dialog>,
                  document.body,
              )
            : null

    return { confirm, ConfirmationDialog }
}

export default useConfirmationDialog
